import { useGetPostMetaQuery } from "@/app/post-internal-chats/post-internal-chats.api";
import { useMemo } from "react";
import { t } from "i18next";

export function usePostMeta(branchId: number) {

    const skip = Number.isNaN(branchId);
    const { data, isLoading, error } = useGetPostMetaQuery({ branchId }, { skip });

    const managersOpts = useMemo(() => data?.managers?.map(m => ({
        id: m.id,
        name: m.name,
        avatar: m.avatar,
    })) ?? [], [data?.managers]);

    const trainingPlanOpts = useMemo(() => data?.trainingPlan?.map(p => ({
        id: p.id,
        name: p.name,
    })) ?? [], [data?.trainingPlan]);

    const nutritionPlanOpts = useMemo(() => data?.nutritionPlan?.map(p => ({
        id: p.id,
        name: p.name,
    })) ?? [], [data?.nutritionPlan]);

    const groupsOpts = useMemo(() => data?.assisteds?.map(g => ({
        id: g.id,
        name: g.name,
    })) ?? [], [data?.assisteds]);

    const specialistsOpts = useMemo(() => data?.assistedSpecialists?.map(s => ({
        id: s.id,
        name: s.name,
    })) ?? [], [data?.assistedSpecialists]);

    const feesOpts = useMemo(() => data?.fees?.map(f => ({
        id: f.id,
        name: f.name,
    })) ?? [], [data?.fees]);

    const reactionsOpts = useMemo(() =>
        data?.typeReactions?.map((v, i) => ({
            id: i + 1,
            name: t(`posts-master.views.reaction_types.${v}`),
        })) ?? [], [data?.typeReactions]
    );

    const setsOpts = useMemo(() => data?.sets?.map(s => ({
        id: s.id,
        name: s.name,
    })) ?? [], [data?.sets]);

    const bondsOpts = useMemo(() => data?.bonds?.map(s => ({
        id: s.id,
        name: s.name,
    })) ?? [], [data?.bonds]);

    const slotsBondsOpts = useMemo(() => data?.slotsBonds?.map(s => ({
        id: s.id,
        name: s.name,
    })) ?? [], [data?.slotsBonds]);

    return {
        managersOpts,
        trainingPlanOpts,
        nutritionPlanOpts,
        groupsOpts,
        specialistsOpts,
        feesOpts,
        reactionsOpts,
        setsOpts,
        bondsOpts,
        slotsBondsOpts,
        data,
        isLoading,
        error,
    };
}
